import XAPPService from "app/Core/services/XAPPService";

export const GET_EMPRESAFINANCEIRO_APONTAMENTOS = "[EMPRESAFINANCEIRO APP] GET APONTAMENTOS";
export const GET_EMPRESAFINANCEIRO_CAIXAS = "[EMPRESAFINANCEIRO APP] GET CAIXAS";
export const GET_EMPRESAFINANCEIRO_EXTRATO = "[EMPRESAFINANCEIRO APP] GET EXTRATO";
export const GET_EMPRESAFINANCEIRO_FATURAMENTO = "[EMPRESAFINANCEIRO APP] GET FATURAMENTO";
export const GET_EMPRESAFINANCEIRO_GRUPODETALHES = "[EMPRESAFINANCEIRO APP] GET GRUPODETALHES";
export const GET_EMPRESAFINANCEIRO_CONTA = "[EMPRESAFINANCEIRO APP] GET CONTAS";
export const GET_EMPRESAFINANCEIRO_CAIXA_NAORECEBIDO = "[EMPRESAFINANCEIRO APP] GET CAIXA NAO RECEBIDO";

export const EMPRESAFINANCEIRO_WARNING = "[EMPRESAFINANCEIRO APP] EMPRESAFINANCEIRO WARNING";
export const EMPRESAFINANCEIRO_INFO = "[EMPRESAFINANCEIRO APP] EMPRESAFINANCEIRO INFO";
export const EMPRESAFINANCEIRO_ERROR = "[EMPRESAFINANCEIRO APP] EMPRESAFINANCEIRO ERROR";
export const CLEAR_REDUCER = "[EMPRESAFINANCEIRO APP] CLEAR REDUCER";

const ListState = [
    "idtarefaprocessoapontamentoitem",
    "idtarefaprocessoapontamentoitemgrupo",
    "idtarefaprocesso",
    "idtarefaprocessoapontamento",
    "idpessoaformulario",
    "nome",
    "idpessoaformulariopai",
    "nomepai",
    "natureza",
    "quantidade",
    "competencia",
    "observacao",
    "valor",
    "valordescricao",
    "valortotal",
    "valortotaldescricao",
    "valorliquido",
    "valorliquidodescricao",
    "idpessoaformularioformapagamento",
    "idpessoaformularioformapagamentodescricao",
    "idpessoaformulariocategoria",
    "idpessoaformulariocategoriadescricao",
    "idpessoaformularioconta",
    "idpessoaformulariocontadescricao",
    "idpessoaformulariocentrocusto",
    "idpessoaformulariocentrocustodescricao",
    "competenciadescricao",
    "vencimento",
    "vencimentodescricao",
    "validacao",
    "validacaodescricao",
    "baixa",
    "baixadescricao",
    "status",
    "statusregistro",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao"
];

const ListStateContas = [
    "idtarefaprocessoapontamentoitem",
    "idtarefaprocessoapontamentoitemgrupo",
    "idtarefaprocesso",
    "idtarefaprocessoapontamento",
    "idpessoaformulario",
    "nome",
    "natureza",
    "naturezadescricao",
    "quantidade",
    "nossonumero",
    "url",
    "linhadigitavel",
    "taxas",
    "taxasdescricao",
    "tarifas",
    "confirmacaopagamento",
    "competencia",
    "observacao",
    "valor",
    "valorgrafico",
    "valordescricao",
    "valortotal",
    "valortotaldescricao",
    "valorliquido",
    "valorliquidodescricao",
    "idpessoaformularioformapagamento",
    "idpessoaformularioformapagamentodescricao",
    "idpessoaformulariocategoria",
    "idpessoaformulariocategoriadescricao",
    "idpessoaformularioconta",
    "idpessoaformulariocontadescricao",
    "idpessoaformulariocentrocusto",
    "idpessoaformulariocentrocustodescricao",
    "competenciadescricao",
    "vencimento",
    "vencimentodescricao",
    "validacao",
    "validacaodescricao",
    "baixa",
    "baixadescricao",
    "status",
    "statusregistro",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao"
];

const ListStateCaixaDetalhe = [
    "idtarefaprocesso",
    "cliente",
    "agendamento",
    "titulos",
];

const ListCaixaState = [
    "recebimento",
    "recebido",
    "validado",
    "valortotalcaixa"
];

const ListExtratoState = [
    "idtarefaprocessoapontamentoitem",
    "idtarefaprocessoapontamentoitemgrupo",
    "naturezadescricao",
    "baixadescricao",
    "valor",
    "valordescricao",
    "saldo",
    "saldodescricao",
    "saldoanteriordescricao",
    "origem",
    "idpessoaformulariocategoria",
    "idpessoaformulariocategoriadescricao",
    "observacao",
];

const ListFaturamentoState = [
    "idtarefaprocessoapontamento",
    "idtarefaprocesso",
    "idtarefaprocessofaturamento",
    "idpessoaformulario",
    "idparent",
    "nome",
    "processonome",
    "valortotal",
    "valortotaldescricao",
    "valortotaltitulo",
    "valortotaltitulodescricao",
    "natureza",
    "naturezadescricao",
    "descricaocomercial",
    "observacao",
    "status",
    "parent",
    "competencia",
    "competenciadescricao",
    "header"
];

const ListDetalhesState = [
    "idtarefaprocessoapontamentoitemgrupo",
    "observacao",
    "valortotal",
    "selecteds",
    "status",
];

const ContaListState = [
    "idpessoaformulario",
    "nome",
    "statusregistro",
];

export function list(_AParams, _AFilter = null) {

    return (dispatch) => {

        dispatch({
            type: GET_EMPRESAFINANCEIRO_APONTAMENTOS,
            payload: null
        });

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "FinanceiroApontamentos", AActions, "spvwtarefaprocessoapontamentoitem", ListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_APONTAMENTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AAction, _AValue, _AParams, _AFilter) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", _AAction, _AValue, "", AConditionsAND, AConditionsOR);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactiontarefaprocessoapontamento", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list(_AParams, _AFilter)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(list(_AParams, _AFilter)));
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function listPagarReceber(_AParams, _AFilter = null) {

    return (dispatch) => {

        dispatch({
            type: GET_EMPRESAFINANCEIRO_APONTAMENTOS,
            payload: null
        });

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "FinanceiroApontamentos", AActions, "spvwempresafinanceirocontas", ListStateContas, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_APONTAMENTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function savePagarReceber(_AAction, _AValue, _AParams, _AFilter) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_.isNull(_AValue.idtarefaprocessoapontamentoitemgrupo) && _AValue.selecteds?.length > 0) {
            _AValue.idtarefaprocessoapontamentoitem = _AValue.selecteds.split(",")[0];
        }

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", _AAction, _AValue, "", AConditionsAND, AConditionsOR);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactiontarefaprocessoapontamento", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(listPagarReceber(_AParams, _AFilter)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(listPagarReceber(_AParams, _AFilter)));
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function listCaixa(_AParams, _AFilter = null) {

    return (dispatch) => {

        Promise.all([
            dispatch({ type: GET_EMPRESAFINANCEIRO_CAIXAS, payload: null }),
            dispatch({ type: GET_EMPRESAFINANCEIRO_CAIXA_NAORECEBIDO, payload: null })
        ]);

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Caixa", AActions, "spvwempresafinanceirocaixa", ListCaixaState, "SELECIONAR", AConditionsAND, AConditionsOR);
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "CaixaNaoRecebido", AActions, "spvwempresafinanceironaorecebido", ["*"], "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_CAIXAS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_CAIXA_NAORECEBIDO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function listCaixaDetalhe(_AParams, _AFilter = null) {

    return (dispatch) => {

        dispatch({
            type: GET_EMPRESAFINANCEIRO_APONTAMENTOS,
            payload: null
        });

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "FinanceiroApontamentos", AActions, "spvwempresafinanceirocaixadetalhe", ListStateCaixaDetalhe, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_APONTAMENTOS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function saveCaixa(_AAction, _AValue, _AParams, _AFilter, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", _AAction, _AValue, "", AConditionsAND, AConditionsOR);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactiontarefaprocessoapontamento", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(listCaixa(_AParams, _AFilter)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(listCaixa(_AParams, _AFilter)));
                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function listExtrato(_AParams, _AFilter = null) {

    return (dispatch) => {

        dispatch({
            type: GET_EMPRESAFINANCEIRO_EXTRATO,
            payload: null
        });

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Extrato", AActions, "spvwempresafinanceiroextrato", ListExtratoState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_EXTRATO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function listFaturamento(_AParams, _AFilter = null) {

    return (dispatch) => {

        dispatch({
            type: GET_EMPRESAFINANCEIRO_FATURAMENTO,
            payload: null
        });

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Faturamento", AActions, "spvwempresafinanceirofaturamento", ListFaturamentoState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_FATURAMENTO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function saveFaturamento(_AAction, _AValue, _AParams, _AFilter) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappCustomActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", _AAction, _AValue, "", AConditionsAND, AConditionsOR);

        XAPPService.XappCustomAction(AActions, _AParams, "spdoactiontarefaprocessoapontamento", "CUSTOM")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(listFaturamento(_AParams, _AFilter)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(listFaturamento(_AParams, _AFilter)));
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function getDetalhes(_AParams, _AFilter = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "financeirogrupoDetalhes", AActions, "spvwtarefaprocessoapontamentoitemgrupo", ListDetalhesState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_GRUPODETALHES,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function listContas(_AAction, _AParams, _AFilter = null) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND !== undefined && _AFilter.AND !== null) {
                AConditionsAND = AConditionsAND.concat(_AFilter.AND);
            }

            if (_AFilter.OR !== undefined && _AFilter.OR !== null) {
                AConditionsOR = AConditionsOR.concat(_AFilter.OR);
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EmpresaContas", AActions, "spvwempresaconta", ContaListState, _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAFINANCEIRO_CONTA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearApontamentos() {
    return {
        type: GET_EMPRESAFINANCEIRO_APONTAMENTOS,
        payload: null
    };
}

export function gerarBoleto(_AAction, _AValue, _AParams, _AFilter) {
    return (dispatch) => {

        var AActions = [];

        AActions = XAPPService.XappIntegracaoActionFactory(_AParams.empresa, AActions, "tarefaprocessoapontamento", _AAction, _AValue);

        XAPPService.XappIntegracaoAction(AActions, _AParams, "PAGSEGURO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(listPagarReceber(_AParams, _AFilter)));
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAFINANCEIRO_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(listPagarReceber(_AParams, _AFilter)));
                }
            }

            ).catch(error => {
                return dispatch({
                    type: EMPRESAFINANCEIRO_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: CLEAR_REDUCER
    };
}